import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'
import { GetIncidentsParams } from './getIncidents'
import { ClaimRequestParam } from './getClaimRequest'

// Get Windows Defender Threat Listing
export const getWindowsDefenderThreatListing = (params: GetIncidentsParams) => {
  return axios.get(endpoints.getWindowDefenderThreatLisiting, { params })
}

export const useWindowsDefenderThreatListing = (params: GetIncidentsParams) => {
  return useQuery([ApiKey.WINDOW_DEFENDER_Listing, ApiKey.list, params], () => getWindowsDefenderThreatListing(params))
}
// Get Windows Defender Claim Request
export const getWindowsDefenderClaimRequest = (params: ClaimRequestParam) => {
  return axios.get(endpoints.getWindowDefenderClaimRequest, { params })
}

export const useWindowsDefenderClaimRequest = (params: ClaimRequestParam) => {
  return useQuery([ApiKey.WINDOW_DEFENDER_Claim_Request, ApiKey.list, params], () => getWindowsDefenderClaimRequest(params))
}

// Raise Claim for Windows Defender
export const raisedClaimWindowsDefender = async (data: object) => {
  return axios.put(endpoints.claimRaisedWindowDefender, data)
}

export const useRaisedClaimWindowsDefender = () => {
  const queryClient = useQueryClient()
  return useMutation(raisedClaimWindowsDefender, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.WINDOW_DEFENDER_Listing, ApiKey.list])
    },
  })
}

// Re-evaluation Request for Windows Defender
export const reEvaluationRequestWindowsDefender = async (data: object) => {
  return axios.put(endpoints.windowDefenderReEvaluationRequest, data)
}

export const useReEvaluationRequestWindowsDefender = () => {
  const queryClient = useQueryClient()
  return useMutation(reEvaluationRequestWindowsDefender, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.WINDOW_DEFENDER_Listing, ApiKey.list])
    },
  })
}
